import { render, staticRenderFns } from "./editReceive.vue?vue&type=template&id=765f3152&scoped=true&"
import script from "./editReceive.vue?vue&type=script&lang=js&"
export * from "./editReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765f3152",
  null
  
)

export default component.exports